import React, { useState } from "react";
import { Avatar, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Skeleton, Tooltip } from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import DeleteIcon from '@mui/icons-material/Delete';
import UserUtils from "../utils/userUtils";
import EmailIcon from '@mui/icons-material/Email';


export const UserList = ({users, onDelete, onMailSend, ...props}) => {

  const [emailDisabled, setEmailDisabled] = useState(false);
  const getSecondaryString = (user) => {
    let str = `Role: ${UserUtils.GetHighestRoleString(user)}`;
    if (user.userStatus != null){
      str = str + `\nStatus: ${UserUtils.GetStatus(user)}`
    }
    return str;
  }

  const onMailSendClick = async (user) => {
    if (!emailDisabled){
      setEmailDisabled(true);
      await onMailSend(user);
      setEmailDisabled(false);
    }
  }

  const getActionButtons = (user, onDelete) => {
    if (!Boolean(onMailSend) && !(Boolean(onDelete))){
      return <></>
    }

    return (
      <>
        {user.userStatus === 0 && onMailSend &&
        <Tooltip title="Send Welcome Email">
          <IconButton edge="end" disabled={emailDisabled} onClick={() => onMailSendClick(user)}>
            <EmailIcon/>
          </IconButton>
        </Tooltip>
        }
        {onDelete &&
          <Tooltip title="Delete"> 
            <IconButton edge="end" onClick={() => onDelete(user)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        }
      </>
    )
  } 
  
  return (
    <List>
      {users ? 
        users.map(user => 
          <ListItem key={user.id}
            secondaryAction={getActionButtons(user, onDelete)}
          >
            <ListItemAvatar>
              <Avatar>
                <PersonIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={user.userName} secondary={getSecondaryString(user)} secondaryTypographyProps={{whiteSpace: 'pre-line'}}/>
          </ListItem>
          ) :
          <Skeleton />
      }
    </List>
  ) 

}